module.exports = __webpack_public_path__ + "img/aboutlogo.a7e5ec4e.png";